import { restClient } from "../../utils/restClient";
import { path } from "../../api";

export default {
  namespaced: true,
  state: {
    list: [],
    pagination: {},
    config: null,
  },
  mutations: {
    SET_LIST(state, responseData) {
      state.list = responseData.data || [];
      state.pagination = responseData;
    },
    SET_CONFIG(state, config) {
      state.config = config;
    },
  },
  actions: {
    async fetchList({ commit }, params) {
      const response = await restClient(
        path.admin.rankingPoints.base,
        "GET",
        null,
        params
      );
      commit("SET_LIST", response.data.data);
      return response;
    },
    async fetchConfig({ commit }) {
      const response = await restClient(path.admin.rankingPoints.config, "GET");
      commit("SET_CONFIG", response.data);
      return response.data;
    },
    async saveConfig({ commit }, data) {
      const response = await restClient(
        path.admin.rankingPoints.config,
        "PUT",
        data
      );
      commit("SET_CONFIG", response.data);
      return response.data;
    },
    async assignPoints(_, data) {
      const response = await restClient(
        path.admin.rankingPoints.assign,
        "POST",
        data
      );
      return response.data.data;
    },
  },
};
